var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase, RestResult } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
var ComputePipelineType = /* @__PURE__ */ ((ComputePipelineType2) => {
  ComputePipelineType2["Cosmos"] = "Cosmos";
  ComputePipelineType2["AzureSpark"] = "AzureSpark";
  return ComputePipelineType2;
})(ComputePipelineType || {});
var ScorecardPurpose = /* @__PURE__ */ ((ScorecardPurpose2) => {
  ScorecardPurpose2["Unknown"] = "Unknown";
  ScorecardPurpose2["StartFast"] = "StartFast";
  ScorecardPurpose2["FastFail"] = "FastFail";
  ScorecardPurpose2["FastFailNoSLA"] = "FastFailNoSLA";
  ScorecardPurpose2["ShipDecision"] = "ShipDecision";
  ScorecardPurpose2["ShipDecisionNoSLA"] = "ShipDecisionNoSLA";
  ScorecardPurpose2["CustomerRequested"] = "CustomerRequested";
  ScorecardPurpose2["NonProduction"] = "NonProduction";
  ScorecardPurpose2["PreviewScorecard"] = "PreviewScorecard";
  ScorecardPurpose2["FastPreviewScorecard"] = "FastPreviewScorecard";
  ScorecardPurpose2["LowPriorityPreviewScorecard"] = "LowPriorityPreviewScorecard";
  return ScorecardPurpose2;
})(ScorecardPurpose || {});
var TimeUnit = /* @__PURE__ */ ((TimeUnit2) => {
  TimeUnit2["Day"] = "Day";
  TimeUnit2["Hour"] = "Hour";
  TimeUnit2["Minute"] = "Minute";
  return TimeUnit2;
})(TimeUnit || {});
var RoundingRule = /* @__PURE__ */ ((RoundingRule2) => {
  RoundingRule2["EvenHours"] = "EvenHours";
  RoundingRule2["Every40Minutes"] = "Every40Minutes";
  RoundingRule2["EveryMinute"] = "EveryMinute";
  RoundingRule2["EveryHour"] = "EveryHour";
  RoundingRule2["EveryDay"] = "EveryDay";
  return RoundingRule2;
})(RoundingRule || {});
var AnalysisTemplateTypeDto = /* @__PURE__ */ ((AnalysisTemplateTypeDto2) => {
  AnalysisTemplateTypeDto2["AB"] = "AB";
  AnalysisTemplateTypeDto2["ForayApp"] = "ForayApp";
  AnalysisTemplateTypeDto2["SeedFinder"] = "SeedFinder";
  AnalysisTemplateTypeDto2["Interleaving"] = "Interleaving";
  AnalysisTemplateTypeDto2["RetrospectiveAA"] = "RetrospectiveAA";
  AnalysisTemplateTypeDto2["AAStream"] = "AAStream";
  return AnalysisTemplateTypeDto2;
})(AnalysisTemplateTypeDto || {});
var ComputeEngineType = /* @__PURE__ */ ((ComputeEngineType2) => {
  ComputeEngineType2[ComputeEngineType2["Cosmos"] = 0] = "Cosmos";
  ComputeEngineType2[ComputeEngineType2["Spark"] = 1] = "Spark";
  return ComputeEngineType2;
})(ComputeEngineType || {});
let MetricServiceResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.metricService, "/api");
    __publicField(this, "CHUNK_SIZE", 8);
  }
  getMetricSets(_0) {
    return __async(this, arguments, function* ({ workspaceId }) {
      const address = `/workspaces/${workspaceId}/metricSets`;
      const result = yield this._get(address);
      return result;
    });
  }
  getAnalysisTemplate(workspaceId, templateName) {
    return __async(this, null, function* () {
      const templateNames = templateName.split(",");
      const chunks = this.chunkArray(templateNames, this.CHUNK_SIZE).filter((chunk) => chunk.length > 0);
      const promises = chunks.map((chunk) => this.fetchTemplates(workspaceId, chunk));
      const results = yield Promise.all(promises);
      const combinedTemplates = [];
      const errors = [];
      results.forEach((result) => {
        if (result.isSuccessful() && result.getSuccessData()) {
          combinedTemplates.push(...result.getSuccessData());
        } else if (!result.isSuccessful()) {
          errors.push(result.getError || "Failed to fetch some templates");
        }
      });
      if (errors.length > 0) {
        return new RestResult(
          JSON.stringify(combinedTemplates),
          "Partial Error",
          206,
          void 0,
          "Failed to fetch some analysis templates"
        );
      } else {
        return new RestResult(JSON.stringify(combinedTemplates), "OK", 200);
      }
    });
  }
  chunkArray(array, chunkSize) {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      const chunk = array.slice(i, i + chunkSize);
      chunks.push(chunk);
    }
    return chunks;
  }
  fetchTemplates(workspaceId, templateNames) {
    if (!templateNames || templateNames.length === 0) {
      return Promise.resolve(new RestResult([], "OK", 200));
    }
    const names = templateNames.join(",");
    const address = `/workspaces/${workspaceId}/AnalysisTemplates/${names}`;
    return this._get(address).then((response) => {
      return response;
    }).catch((error) => {
      return new RestResult([], "Error", 500, void 0, error.toString());
    });
  }
  getAnalysisTemplateFromVersion(workspaceId, metricSetName, metricSetVersionName, templateName) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/0/${metricSetVersionName}/AnalysisTemplates/${templateName}`;
      return yield this._get(address);
    });
  }
  getMetricVersionsByMetricSetName(metricSet, workspaceId, top = 90, skip = 0) {
    return __async(this, null, function* () {
      const path = `/workspaces/${workspaceId}/metricsets/${encodeURIComponent(
        metricSet
      )}/published-infos?isDraft=true&count=${top}&offset=${skip}`;
      const result = yield this._get(path);
      if (result.statusCode === 400 || result.statusCode === 404) {
        return RestResult.fromResult({ Data: [] }, true);
      }
      return result;
    });
  }
  getMetricSetSegments(metricSet, versionName, workspaceId) {
    return __async(this, null, function* () {
      const path = `/workspaces/${workspaceId}/metricsets/${encodeURIComponent(metricSet)}/versions/${versionName}/segment-names`;
      const result = yield this._get(path);
      if (result.statusCode === 400 || result.statusCode === 404) {
        return RestResult.fromResult([], true);
      }
      return result;
    });
  }
  getAnalysisTemplateNames(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/AnalysisTemplatesNames`;
      const result = yield this._get(address);
      if (result.statusCode === 404 || result.statusCode === 401 || result.statusCode === 400) {
        return RestResult.fromResult([]);
      }
      return result;
    });
  }
  getAnalysisTemplateNamesFromVersion(workspaceId, metricSetName, metricSetVersionName) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/metricSets/${metricSetName}/0/${metricSetVersionName}/AnalysisTemplates`;
      const result = yield this._get(address);
      if (result.statusCode === 404 || result.statusCode === 401 || result.statusCode === 400) {
        return RestResult.fromResult([]);
      }
      return result;
    });
  }
  getMetrics(workspaceId, query, data) {
    return __async(this, null, function* () {
      const path = `/workspaces/${workspaceId}/metricsInAnalysisTemplates?query=${query}&matchTabGroupName=false`;
      const result = yield this._post(data, path);
      if (result.statusCode === 404 || result.statusCode === 401 || result.statusCode === 400) {
        return RestResult.fromResult([]);
      }
      return result;
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while fetching analysis template from metric service.` })
], MetricServiceResource.prototype, "getAnalysisTemplate", 1);
MetricServiceResource = __decorateClass([
  WPSProxyConverter()
], MetricServiceResource);
const MetricServiceResource$1 = new MetricServiceResource();
export {
  AnalysisTemplateTypeDto,
  ComputeEngineType,
  ComputePipelineType,
  RoundingRule,
  ScorecardPurpose,
  TimeUnit,
  MetricServiceResource$1 as default
};
//# sourceMappingURL=MetricServiceResource.js.map
